import * as routerNames from '@/services/router/router.names'

import DevelopersHome from '@/screens/developers/developers-home.vue'
import OutboundWebhooks from '@/screens/developers/outbound-webhooks.vue'

export default [
  {
    path: '/:accountId/developers/home',
    name: routerNames.DEVELOPERS_HOME,
    component: DevelopersHome,
    meta: {
      adminOwnerOnly: true,
    },
  },
  {
    path: '/:accountId/developers/webhooks',
    name: routerNames.DEVELOPERS_OUTBOUND_WEBHOOKS,
    component: OutboundWebhooks,
    meta: {
      adminOwnerOnly: true,
    },
  },
]
